import { CircularProgress, makeStyles, Paper } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(() => ({
    component: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px 15px',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
    }
}))

const AccessLoader = () => {
    const classes = useStyles()

    return (
        <Paper className={classes.component}>
            <CircularProgress />
        </Paper>
    )
}

export default AccessLoader
